if (!customElements.get('faq-accordion-section')) {
  class FaqAccordionSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.allowMultiple = this.dataset.allowMultiple === 'true';
      this.items = Array.from(this.querySelectorAll('.faq-accordion__item'));
      this.handleTriggerClick = this.onTriggerClick.bind(this);
      this.handleResize = this.onResize.bind(this);

      this.items.forEach((item) => {
        const trigger = item.querySelector('.faq-accordion__trigger');
        const panel = item.querySelector('.faq-accordion__panel');

        if (!(trigger instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;

        if (item.classList.contains('is-open')) {
          panel.style.height = 'auto';
        } else {
          panel.style.height = '0px';
        }

        trigger.addEventListener('click', this.handleTriggerClick);
      });

      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      if (!this.handleTriggerClick) return;

      this.items.forEach((item) => {
        const trigger = item.querySelector('.faq-accordion__trigger');
        if (trigger instanceof HTMLElement) {
          trigger.removeEventListener('click', this.handleTriggerClick);
        }
      });

      window.removeEventListener('resize', this.handleResize);
    }

    onTriggerClick(event) {
      const trigger = event.currentTarget;
      const item = trigger.closest('.faq-accordion__item');
      if (!(item instanceof HTMLElement)) return;

      const shouldOpen = !item.classList.contains('is-open');

      if (shouldOpen && !this.allowMultiple) {
        this.items.forEach((otherItem) => {
          if (otherItem !== item) this.closeItem(otherItem);
        });
      }

      if (shouldOpen) {
        this.openItem(item);
      } else {
        this.closeItem(item);
      }
    }

    onResize() {
      this.items.forEach((item) => {
        if (!item.classList.contains('is-open')) return;

        const panel = item.querySelector('.faq-accordion__panel');
        const inner = item.querySelector('.faq-accordion__panel-inner');
        if (!(panel instanceof HTMLElement) || !(inner instanceof HTMLElement)) return;

        panel.style.height = `${inner.offsetHeight}px`;

        requestAnimationFrame(() => {
          if (item.classList.contains('is-open')) {
            panel.style.height = 'auto';
          }
        });
      });
    }

    openItem(item) {
      const trigger = item.querySelector('.faq-accordion__trigger');
      const panel = item.querySelector('.faq-accordion__panel');
      const inner = item.querySelector('.faq-accordion__panel-inner');

      if (!(trigger instanceof HTMLElement) || !(panel instanceof HTMLElement) || !(inner instanceof HTMLElement)) return;

      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');

      const startHeight = panel.offsetHeight;
      const endHeight = inner.offsetHeight;

      panel.style.height = `${startHeight}px`;
      requestAnimationFrame(() => {
        panel.style.height = `${endHeight}px`;
      });

      panel.addEventListener(
        'transitionend',
        () => {
          if (item.classList.contains('is-open')) {
            panel.style.height = 'auto';
          }
        },
        { once: true }
      );
    }

    closeItem(item) {
      const trigger = item.querySelector('.faq-accordion__trigger');
      const panel = item.querySelector('.faq-accordion__panel');
      const inner = item.querySelector('.faq-accordion__panel-inner');

      if (!(trigger instanceof HTMLElement) || !(panel instanceof HTMLElement) || !(inner instanceof HTMLElement)) return;

      const startHeight = panel.style.height === 'auto' ? inner.offsetHeight : panel.offsetHeight;

      panel.style.height = `${startHeight}px`;
      requestAnimationFrame(() => {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.style.height = '0px';
      });
    }
  }

  customElements.define('faq-accordion-section', FaqAccordionSection);
}
